(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('PainelMaquinasWrapperCtrl', PainelMaquinasWrapperController);

  PainelMaquinasWrapperController.$inject = [
    '$scope',
    '$routeParams',
    '$route',
    '$location'
  ];

  // eslint-disable-next-line max-params
  function PainelMaquinasWrapperController($scope, $routeParams, $route, $location) {
    const vm = this;

    vm.currentTab = $routeParams.maquinaTab || 'usos';

    vm.selectTab = selectTab;

    function selectTab(name) {
      $location.search('maquinaTab', name);
    }

    $scope.$root.initialize
      .then(() => {
        if (!$scope.$root.permissions.usosMaquinas.canRead) {
          vm.currentTab = 'painel';
        }
      });

    $scope.$on('$routeUpdate', () => {
      vm.currentTab = $routeParams.maquinaTab;
    });

    $scope.$on('$destroy', () => {
      if (!$routeParams.selections) {
        $route.updateParams({
          maquinaTab: null
        });
      }
    });
  }
}());
